// socket.js
import { io } from 'socket.io-client';
import { KTC_API_ENABLE_SOCKET, KTC_API_URL_SOCKET } from '../constants/api';
//console.log('KTC_API_URL_SOCKET:', KTC_API_URL_SOCKET);

const socket =
  KTC_API_ENABLE_SOCKET === 'true'
    ? io(KTC_API_URL_SOCKET, {
        withCredentials: true,
        transports: ['websocket'],
      })
    : null;

// console.log('socket', socket);
// export default socket;
// const socket = io(KTC_API_URL_SOCKET, {
//   withCredentials: true,
//   transports: ['websocket'], // optional, for stability
// });
//console.log('Socket connected:', socket.id);

export default socket;
